import { connect } from 'react-redux'
import Distributor from './Distributor'

const mapStateToProps = state => ({
  stock: state.stock
})

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Distributor)
